'use client'

import { Separator } from 'react-aria-components/Separator'

import { css } from '../../../../styled-system/css'

export function DropdownSeparator() {
    return (
        <Separator
            className={css({
                backgroundColor: 'neutral.200',
                height: '[1px]',
                width: 'full',
                marginY: '2',
            })}
        />
    )
}
